import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiParameter,
    HasPagingParameters,
    ServiceResult,
    del,
    get,
    patch,
    post,
} from "@insite/client-framework/Services/ApiService";
import {
    BaseModel,
    InvoiceCollectionModel,
    InvoiceModel,
    PaginationModel,
} from "@insite/client-framework/Types/ApiModels";

export interface ADIInvoiveDetailsParams extends ApiParameter {
    invoiceNumber: string;
    expand?: any;
    invoiceType: string | undefined; // added ---P21 Change
}

export interface ADIInvoiveDetailsModal extends BaseModel {
    invoices: InvoiceModel[];
    pagination: PaginationModel;
    showErpOrderNumber: Boolean;
}

export interface GetInvoicePaymentRecapApiParameter extends ApiParameter, HasPagingParameters {
    invoiceNumber?: string;
    orderNumber?: string;
    poNumber?: string;
    search?: string;
    status?: string[];
    customerSequence?: string;
    fromDate?: string;
    toDate?: string;
    showOpenOnly?: boolean;
    properties?: any;
}

export interface DeleteInvoiceRecapLineApiParameter {
    invoiceNumber: string;
}

//added variables and Interface ---- P21 Change
interface BankPaymentType {
    paymentTypeId: number;
    paymentMethodId: string;
    paymentTypeDesc: string;
}
interface BankPeriodDetails {
    period: string;
    yearForPeriod: string;
}
export interface BankAccountsModel extends BaseModel {
    bankPaymentInfomration: BankAccount[];
    bankPaymentType: BankPaymentType[];
    bankPeriodDetails: BankPeriodDetails[];
}

export interface BankAccount extends ApiParameter {
    paymentType?: string;
    accountType?: string;
    accountDescription?: string;
    routineNumber?: string;
    bankAccountNumber?: string;
    termsAgreed?: string;
    creditCardType?: string;
    creditCardNumber?: string;
    creditCardToken?: string;
    creditCardExpirationDate?: string;
    isDefault?: boolean;
    cardCVC?: any;
    postalCode?: any;
    id?: string;
    uri?: string;
    properties?: any;
    bankId?: number;
    bankNumber?: string;
    paymentTypeId?: string;
    paymentMethodId?: string;
    paymentTypeDesc?: string;
    period?: string;
    yearForPeriod?: string;
}

export interface ADIInvoicePaymentResponseModel extends BaseModel {
    accountType: string;
    accountDescription: string;
    routineNumber: string;
    bankAccountNumber: string;
    returnCode: string;
    returnMessage: string;
    paymentConfirmationNumber: string;
    creditCardAuthorizeCode: string;
    creditCardExpirationDate: string;
    creditCardType: string;
    creditCardNumber: string;
    paymentType: string;
    termsAgreed: string;
    companyName: string;
    address1: string;
    address2: string;
    city: string;
    stateProv: string;
    zipCode: string;
    currentUserEmail: string;
    termsAgreementPDFPath: string;
}

export interface ReasonCodes {
    ReasonCode: string;
    ReasonCodeDescription: string;
}

export interface UpdateInvoiceParams {
    invoicehistorycollection: InvoicePaymentModel[];
}

export interface ADIInvoiveDetailsParams extends ApiParameter {
    invoiceNumber: string;
    expand?: any;
}

export interface ADIInvoiveDetailsModal extends BaseModel {
    invoices: InvoiceModel[];
    pagination: PaginationModel;
    showErpOrderNumber: Boolean;
}

export interface InvoiceResultModel {
    uri: string;
    invoices: Invoice[];
    pagination: Pagination;
    showErpOrderNumber: boolean;
    properties: Properties2;
    isErpAvailable: boolean;
}

export interface Invoice {
    uri: string;
    id: string;
    invoiceNumber: string;
    invoiceDate: string;
    dueDate: string;
    invoiceType: string;
    customerNumber: string;
    customerSequence: string;
    customerPO: string;
    status: string;
    isOpen: boolean;
    currencyCode: string;
    terms: string;
    shipCode: string;
    salesperson: string;
    btCompanyName: string;
    btAddress1: string;
    btAddress2: string;
    billToCity: string;
    billToState: string;
    billToPostalCode: string;
    btCountry: string;
    stCompanyName: string;
    stAddress1: string;
    stAddress2: string;
    shipToCity: string;
    shipToState: string;
    shipToPostalCode: string;
    stCountry: string;
    notes: string;
    productTotal: number;
    discountAmount: number;
    shippingAndHandling: number;
    otherCharges: number;
    taxAmount: number;
    invoiceTotal: number;
    currentBalance: number;
    invoiceLines: any[];
    invoiceHistoryTaxes: any[];
    invoiceTotalDisplay: string;
    productTotalDisplay: string;
    discountAmountDisplay: string;
    taxAmountDisplay: string;
    shippingAndHandlingDisplay: string;
    otherChargesDisplay: string;
    currentBalanceDisplay: string;
    orderTotalDisplay: any;
    shipViaDescription: any;
    customerVatNumber: string;
    properties: Properties;
}

export interface Properties {
    showPayButton: string;
    trlrInd: string;
    custLocation: string;
    showInvPrintPayLink: string;
    orderNumber: string;
    isDuplicateInvoicePayment: string;
    invType: string;
}

export interface Pagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: any;
    sortType: any;
    nextPageUri: string;
    prevPageUri: any;
}

export interface Properties2 {
    disableTypeInvoice: string;
    disableTypeCM: string;
    disableBalance1_30: string;
    disableBalance31_60: string;
    disableBalance61_90: string;
    disableBalanceOver90: string;
    aging: string;
    balance1_30: string;
    balance31_60: string;
    balance61_90: string;
    balanceOver90: string;
    currentBalance: string;
    totalBalance: string;
    totalItems: string;
    custNumber: string;
    address1: string;
    address2: string;
    address3: string;
    address4: string;
    companyName: string;
    compCode: string;
    creditRep: string;
    email: string;
    faxNumber: string;
    phoneNumber: string;
    recordCnt: string;
    returnMsg: string;
    allowBankPayment: string;
    allowCCPayment: string;
    returnCode: string;
    suffix: string;
    reasonCodes: string;
    showPaymentButton: string;
}

export interface InvoiceParams extends ApiParameter {
    customerSequence?: string;
    sort?: string;
    dateType?: string;
    toDate?: string;
    fromDate?: string;
    poNumber?: string;
    invoiceNumber?: string;
    refrencenumber?: string;
    invoiceType?: string;
    invoiceTypeDesc?: string;
    selectedpage?: number;
    isSearch?: boolean;
    showOpenOnly?: boolean;
    dateRange?: string;
    dateRangeDesc?: string;
    invoiceFilterType?: string;
    invoiceFilterData?: string;
    dpdFilterType?: string;
    dpdFilterData?: string;
    properties?: any;
    page?: string;
    pageSize?: string;
    formattedFromDate?: string;
}

export interface MultipleInvoiceResultsModel {
    uri: any;
    custNumber: string;
    curDate: string;
    curPage: string;
    lastPage: string;
    totRecords: string;
    totGrand: string;
    totCurrent: string;
    tot01_30: string;
    tot31_60: string;
    tot61_90: string;
    tot90_Over: string;
    returnCode: any;
    invlineitem: Invlineitem[];
    properties: Properties;
}

export interface Invlineitem {
    customerSuffix: string;
    city: string;
    state: string;
    curAmount: string;
    tot01_30: string;
    tot31_60: string;
    tot61_90: string;
    tot90_Over: string;
    totAmount: string;
    showViewLink: boolean;
}

export interface Properties {}

export interface InvoicePaymentModel {
    InvoiceId: string;
    InvoicePaymentAmount: string;
    ReasonCode: string;
    PO: string;
    RefNumber: string;
    BalanceDue: string;
    DueDate: string;
    Type: string;
    InvoiceDate: string;
    InvoiceTotal: string;
    TrlrInd: string;
    orderNumber: string;
    properties?: any;
}

const getInvoiceDetailsUrl = "/api/v2/invoicedetails";
const invoicesUrl = "/api/v1/invoices";
const removeInvoiceUrl = "/api/v3/invoice/";
const multipleInvoiceUrl = "/api/v2/multipleinvoicelocations";
const invoiceRecapUrl = "/api/v3/invoice/updateinvoicepayment";
const bankDetailsUrl = "/api/v2/bankdetails";
const invoicePaymentUrl = "/api/v2/invoicepayment";
const sendEmailUrl = "/api/v3/invoice/sendconfirmationemail";

export async function getADIInvoices(parameter: InvoiceParams) {
    let filterParameter: InvoiceParams = {
        ...parameter,
        fromDate: parameter.formattedFromDate ? parameter.formattedFromDate : parameter.fromDate,
    };
    const response = await get<InvoiceResultModel>(invoicesUrl, filterParameter);
    return response;
}

export async function getADIMultipleInvoices(parameter: InvoiceParams) {
    const response = await get<MultipleInvoiceResultsModel>(multipleInvoiceUrl, parameter);
    return response;
}
export async function updateInvoicePaymentMethod(parameter: UpdateInvoiceParams) {
    const response = await post<any>(invoiceRecapUrl, parameter);
    return response;
}

export async function getInvoicePaymentRecap(parameter: GetInvoicePaymentRecapApiParameter) {
    const invoices = await get<InvoiceCollectionModel>(invoicesUrl, parameter);
    return invoices;
}

//Changes in method -----P21 Change
export async function getInvoiceDetails(parameter: ADIInvoiveDetailsParams) {
    const invoiceNumber = parameter.invoiceNumber;
    const newParameter: Partial<ADIInvoiveDetailsParams> = { ...parameter };
    if (newParameter.invoiceNumber !== undefined) delete newParameter.invoiceNumber;
    const invoice = await get<ADIInvoiveDetailsModal>(
        `${getInvoiceDetailsUrl}/${invoiceNumber}/${parameter.invoiceType}?expand=invoicelines,shipments`,
        newParameter,
    );
    return invoice;
}

export function deleteInvoiceRecapLine(parameter: DeleteInvoiceRecapLineApiParameter) {
    return del(`${removeInvoiceUrl}/${parameter.invoiceNumber}`);
}

export async function deleteInvoiceRecapLineWithResult(parameter: DeleteInvoiceRecapLineApiParameter): Promise<any> {
    try {
        const result = await deleteInvoiceRecapLine(parameter);
        return {
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        if (isApiError(error) && error?.status === 404) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
            };
        }
        throw error;
    }
}

// export async function getBankAccounts(parameter: any) {

//     const bankAccounts = await get<BankAccountsModel>(bankDetailsUrl, parameter);

//     return bankAccounts;
// }

export async function getBankAccounts(parameter: any): Promise<any> {
    try {
        const response = await fetch(bankDetailsUrl, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const bankAccounts: BankAccountsModel = await response.json();
        return bankAccounts;
    } catch (error) {}
}

export function payInvoice(parameter: BankAccount) {
    return patch<ADIInvoicePaymentResponseModel>(`${invoicePaymentUrl}`, parameter);
}

export function sendEmail(parameter: any) {
    return post(`${sendEmailUrl}`, parameter);
}
